import { useState } from "react";
import { type ChatPageContext, setChatPageContext } from "./chat-controller";

export function KitsCopilotPageContext(context: ChatPageContext) {
    return (
        <ChatPageContextRegistration
            key={JSON.stringify(context)}
            context={context}
        />
    );
}

function ChatPageContextRegistration({
    context,
}: {
    context: ChatPageContext;
}) {
    const [register] = useState(() => {
        const snapshot = structuredClone(context);
        return (node: HTMLSpanElement | null) => {
            if (!node) return;
            return setChatPageContext(snapshot);
        };
    });
    return <span ref={register} hidden />;
}
